module.exports = __webpack_public_path__ + "img/Graph-icon16.png";